import { reactive } from 'vue'

const globalLoading = reactive({
  visible: false,
  description: 'Please wait...', 
})

export const useGlobalLoading = () => globalLoading